import React from "react";

export default function About(){
    return (
    <div class="homepg">
        <div className="column">
            <h2>about molly</h2>
                <img className="aboutpic" src="molly.jpg" height="600" width="750" alt="profile"></img>
        </div>
        <div className="column">
            <p className="about">
            Molly is a graduate of the Massachusetts Institute of Technology Professional Coding Certificate Program in Full Stack Web Development using MERN.
            <br/><br/>
            Currently, Molly is a freelance User Interface Designer and specializes in Reactjs and Nextjs. Her professional background also consists of independent consulting for various industries, including Social Media Management, Landscape and Interior Design, Property Management, and Vegetation Management.
            <br/><br/>
            In her free time, Molly can be found running up wooded trails, exploring the sea in her kayak, teaching her cat new tricks, practicing German or Italian, and laughing with her fiance.
            </p>
            <p className="about">
            With a growing technical aptitude, Molly is proficient in many trusted digital resources and enjoys learning new software, staying up to date with trending topics and disciplines, and applying her knowledge to benefit her valued clients.
            <br/><br/>
            Create React App & React from scratch
            <br/>
            Nextjs & Vercel
            <br/>
            Git and command line interface
            <br/>
            HTML, JavaScript, CSS
            <br/>
            Amazon Web Services
            <br/>
            SQL, MongoDB, Docker
            <br/>
            Strapi, Drupal
            <br/>
            Social Media platforms and analytical software (Sprout Social)
            <br/>
            WordPress development, Blaze
            <br/>
            Canva, Adobe, Clipchamp, Vimeo
            <br/>
            Google Business Profile, Google Workspace, Salesforce Administration
            <br/>
            ArcMaps, ArcGIS, ArcDesktop
            <br/>
            Microsoft Office
            </p>
        </div>
    </div>
    )
}